import React from 'react';

const NoLoansFound = () => (
  <div className="c-heading c-heading--small u-mt" data-automation-id="no-loans-found">
    No loans found.
  </div>
);

export default NoLoansFound;

